export default "__VITE_ASSET__Bp0ETba$__"